export function pageView(url: string) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: url
    });
  }
}

type ItemLayerProps = {
  totalPrice: number;
  productPrice: number;
  productName: string;
  productId: string;
  diet: string;
  allergies: string[];
  quantity: number;
};

export function checkout(props: ItemLayerProps) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: {
        value: props.totalPrice,
        currency: 'EUR',
        items: [
          {
            item_id: props.productId,
            item_name: props.productName,
            price: props.productPrice,
            quantity: props.quantity,
            diet: props.diet,
            allergies:
              props.allergies.length > 0 ? props.allergies.join(', ') : 'None'
          }
        ]
      }
    });
  }
}

export function purchase(props: ItemLayerProps, transactionId: string) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        value: props.totalPrice,
        transaction_id: transactionId,
        currency: 'EUR',
        items: [
          {
            item_id: props.productId,
            item_name: props.productName,
            price: props.productPrice,
            quantity: props.quantity,
            diet: props.diet,
            allergies:
              props.allergies.length > 0 ? props.allergies.join(', ') : 'None'
          }
        ]
      }
    });
  }
}

export function custom_event(
  eventName: string,
  eventData: Record<string, any>
) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData
    });
  }
}
